import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import theme from 'src/theme';

export const useStyles = makeStyles<Theme>(() => ({
  bgWhite: {
    background: theme.palette.common.white,
  },
}));
